import React from 'react';
import { StyledDrawer } from "./style";
import { useSelector } from 'react-redux';
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from '@mui/material/styles';
import DrawerContent from "./DrawerContent";

const Drawer = () => {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('md'));
    const user = useSelector(state => state.user.user);

    if (!user || mobile) return null;

    return (
        <StyledDrawer variant="permanent">
            <DrawerContent />
        </StyledDrawer>
    );
};

export default Drawer;
